import { combineReducers } from 'redux';

import production from './ProductionReducer';
import currentSlide from './CurrentSlideReducer';
import accordion from './AccordionReducer';
import session from './SessionReducer';
import slideViewer from './SlideViewerReducer';
import menu from './MenuReducer';
import undoRedo from './UndoRedoReducer';
import music from './MusicReducer';
import audioEditor from './AudioEditorReducer';

export default combineReducers({
    production,
    currentSlide,
    accordion,
    session,
    slideViewer,
    menu,
    undoRedo,
    music,
    audioEditor
});



/** WEBPACK FOOTER **
 ** ./src/reducers/Reducer.js
 **/